import { createContext } from 'react';
import { Target } from '../../../types';

export type HoverTargetOptions = { [username: string]: Target | undefined };

export const HoverTargetContext = createContext<HoverTargetOptions>({});
